module.exports = __webpack_public_path__ + "img/in-vtic.96c93593.png";